module.exports = __webpack_public_path__ + "img/icon-celular-green-success.9d56473e.svg";